/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesReferentialDto } from './FeesReferentialDto';
import {
    FeesReferentialDtoFromJSON,
    FeesReferentialDtoFromJSONTyped,
    FeesReferentialDtoToJSON,
    FeesReferentialDtoToJSONTyped,
} from './FeesReferentialDto';
import type { VariablesReferentialDto } from './VariablesReferentialDto';
import {
    VariablesReferentialDtoFromJSON,
    VariablesReferentialDtoFromJSONTyped,
    VariablesReferentialDtoToJSON,
    VariablesReferentialDtoToJSONTyped,
} from './VariablesReferentialDto';
import type { GuaranteeReferentialDto } from './GuaranteeReferentialDto';
import {
    GuaranteeReferentialDtoFromJSON,
    GuaranteeReferentialDtoFromJSONTyped,
    GuaranteeReferentialDtoToJSON,
    GuaranteeReferentialDtoToJSONTyped,
} from './GuaranteeReferentialDto';

/**
 * 
 * @export
 * @interface GlobalContractsCommandDto
 */
export interface GlobalContractsCommandDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalContractsCommandDto
     */
    riskId: string;
    /**
     * List of custom global guarantees fees
     * @type {Array<GuaranteeReferentialDto>}
     * @memberof GlobalContractsCommandDto
     */
    guarantees?: Array<GuaranteeReferentialDto>;
    /**
     * List of custom global tunnel fees
     * @type {Array<FeesReferentialDto>}
     * @memberof GlobalContractsCommandDto
     */
    fees?: Array<FeesReferentialDto>;
    /**
     * List of custom global tunnel variables
     * @type {Array<VariablesReferentialDto>}
     * @memberof GlobalContractsCommandDto
     */
    variables?: Array<VariablesReferentialDto>;
}

/**
 * Check if a given object implements the GlobalContractsCommandDto interface.
 */
export function instanceOfGlobalContractsCommandDto(value: object): value is GlobalContractsCommandDto {
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    return true;
}

export function GlobalContractsCommandDtoFromJSON(json: any): GlobalContractsCommandDto {
    return GlobalContractsCommandDtoFromJSONTyped(json, false);
}

export function GlobalContractsCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalContractsCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'riskId': json['riskId'],
        'guarantees': json['guarantees'] == null ? undefined : ((json['guarantees'] as Array<any>).map(GuaranteeReferentialDtoFromJSON)),
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesReferentialDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(VariablesReferentialDtoFromJSON)),
    };
}

export function GlobalContractsCommandDtoToJSON(json: any): GlobalContractsCommandDto {
    return GlobalContractsCommandDtoToJSONTyped(json, false);
}

export function GlobalContractsCommandDtoToJSONTyped(value?: GlobalContractsCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskId': value['riskId'],
        'guarantees': value['guarantees'] == null ? undefined : ((value['guarantees'] as Array<any>).map(GuaranteeReferentialDtoToJSON)),
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesReferentialDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(VariablesReferentialDtoToJSON)),
    };
}

